<template>
  <div class="gmf-nav-dots">
    <div class="gmf-nav-dot" v-for="i in count" :key="i" :class="{'gmf-active': i-1 == modelValue}" @click.stop.prevent="onClick(i-1)" />
  </div>
</template>

<style>
.gmf-nav-dots {
  display: inline-flex;
  gap: var(--gmf-p-3);
}
.gmf-nav-dot {
  width: 12px;
  height: 12px;
  background: var(--gmf-col-gray);
  border-radius: 99px;
  cursor: pointer;
  transition: 0.2s background linear;
}
.gmf-nav-dot.gmf-active {
  background: var(--gmf-col-darkgray);
}
</style>

<script>
export default {
  props: ['modelValue', 'count'],
  methods: {
    onClick (i) {
      this.$emit('update:modelValue', i);
    },
  },
};
</script>
